import React, { useState } from "react";
// models
import { PostulacionModel, initialValuesPostulacionModel } from "../models/PostulacionesModel/postulacion.model";
// api services
import apiParticipantes from "../api/Participantes/api-participantes";
// another imports
import fileDownload from "js-file-download";
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
import { openNotification } from '../utils/Notifactions';
import DocumentosService from "../api/Documentos/api-documentos";
import getStorageUser from "../middlewares/GetStorageUser";

export const useMisBeps = () => {
  const [postulaciones, setPostulaciones] = useState<any>([]);
  const [postulacionState, setPostulacionState] = useState<any>({});
  const [totalregistros, setTotalregistros] = useState<number>(0);
  const [cantidadpáginas, setCantidadPáginas] = useState<number>(10);
  const [modal, setModal] = useState<boolean>(false);
  const [lineasconvocatoria, setLineasConvocatorias] = useState<any>([]);
  const [postulacion, setPostulacion] = useState<PostulacionModel>(initialValuesPostulacionModel);
  // subsanar documentos
  const [documentossubsanar, setDocumentosSubsanar] = useState<any>([]);
  const [totaldocumentossubsanar, setTotalDocumentosSubsanar] = useState<number>(0);
  const [cantidadpáginassubsanar, setCantidadPáginasSubsanar] = useState<number>(10);
  const [openModalWarning, setOpenModalWarning] = useState(false);
  const [datosFiltrados, setDatosFiltrados] = useState([])

  const onAceptar = () => {
    return setOpenModalWarning(false);
  };

  const cargarPostulaciones = async (artistCall?: boolean) => {
    // 
    const user = getStorageUser()
    //console.log(user);
    let { postulacionesBeps } = await apiParticipantes.obtenerPostulacionesBepsDocumento(user.documento);
    //console.log(postulacionesBeps);
    const subsanar = [];
    setTotalregistros(postulacionesBeps.length);
    for (const postulacion of postulacionesBeps) {
      if (postulacion.estado === "Subsanar") {
        const convocatoria = await apiConvocatorias.getConvocatoriaById(postulacion.convocatoria_id);
        console.log(convocatoria);
        let fecha_informe = convocatoria.data.fechas.filter((item:any)=> item.clave === "Primer informe de verificación de documentos");
        
        const fechaInforme = new Date(fecha_informe[0].valormax);
        const fechaActual = new Date();
        if (fechaActual > fechaInforme) {
          subsanar.push(postulacion);
        }
      }
    }
    setDatosFiltrados(postulacionesBeps);
    setDocumentosSubsanar(subsanar);
    setTotalDocumentosSubsanar(subsanar.length);
    if (subsanar && subsanar.length > 0) setOpenModalWarning(true);
    return setPostulaciones(postulacionesBeps);
  };
  const guardarArchivosAdministrativos = async (datos: any, e: any, index: number, post: Array<PostulacionModel>) => {
    try {
      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      const formData = new FormData();
      formData.append("archivo", e.target.files[0]);
      const data = await DocumentosService.guardarArchivo(formData);
      //console.log(datos.tipo_documento);
      let nuevosdocumentos: any = postulacionState.documentos_administrativos.map((doc: any, indexdoc: number) => {
        if (!doc.tipo_documento) doc.tipo_documento = doc.descripcion;
        if (datos.tipo_documento === doc.tipo_documento) {
          //console.log("es igual");
          return {
            ...doc,
            url_participante: data.data,
            checksubsanable: false,
            checksubsanado: true,
          };
        }
        return {
          ...doc,
        };
      });
      //console.log(nuevosdocumentos, "termine de cambiar");
      // cambiarEstadoPostulaciónDocumentos(nuevosdocumentos, nuevaspostulaciones);
      let infoupdate = [...documentossubsanar];
      for (var i in infoupdate) {
        infoupdate[i].documentos_administrativos = nuevosdocumentos;
      }
      setDocumentosSubsanar(infoupdate);
      return setPostulacionState({ ...postulacionState, documentos_administrativos: nuevosdocumentos });
    } catch (error) {
      return console.error(error);
    }
  };
  const cambiarEstadoPostulaciónDocumentos = async () => {
    let nuevaspostulaciones = postulaciones.map((data: any) => {
      if (data.id_postulacion === postulacionState.id_postulacion) {
        return postulacionState;
      }
      return data;
    });
    //console.log(postulacionState.documentos_administrativos, "documentos antes de pasar");
    await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
      postulacionState.id_postulacion,
      postulacionState.documentos_administrativos
    );
    let estado = "Subsanado";
    let subsanar = postulacionState.documentos_administrativos.filter((data: any) => data.checksubsanable);
    //console.log(subsanar);
    //console.log(postulacionState.documentos_administrativos);
    if (subsanar.length > 0) estado = "Subsanar";
    await apiParticipantes.cambiarEstadoPostulacion({
      id_postulacion: postulacionState.id_postulacion,
      estado: estado,
    });
    return setPostulaciones(nuevaspostulaciones);
  };
  const cambiarCantidadPaginas = (e: any, value: any) => {
    return setCantidadPáginas(value);
  };
  const cambiarCantidadPaginasDocumentos = (e: any, value: any) => {
    return setCantidadPáginasSubsanar(value);
  };
  const descargarArchivo = async (url: string) => {
    let data: any = await DocumentosService.consultarArchivo(url);
    await fileDownload(data, url);
  };
  const obtenerLineasConvocatorias = async () => {
    let data = await apiConvocatorias.getLineaConvocatorias();
    //console.log(data);
    return setLineasConvocatorias(data.data);
  }
  const verPropuesta = (datos: PostulacionModel) => {
    setPostulacion(datos);
    return setModal(true);
  }

  return{
    postulaciones,
    setPostulaciones,
    cargarPostulaciones,
    guardarArchivosAdministrativos,
    setPostulacionState,
    totalregistros,
    setTotalregistros,
    cantidadpáginas,
    cambiarCantidadPaginas,
    documentossubsanar,
    totaldocumentossubsanar,
    cantidadpáginassubsanar,
    cambiarCantidadPaginasDocumentos,
    cambiarEstadoPostulaciónDocumentos,
    modal,
    setModal,
    descargarArchivo,
    obtenerLineasConvocatorias,
    lineasconvocatoria,
    postulacion,
    setPostulacion,
    verPropuesta,
    setDocumentosSubsanar,
    datosFiltrados,
    setDatosFiltrados,
    openModalWarning,
    setOpenModalWarning,
    onAceptar
  }
}